import { createAsyncThunk } from '@reduxjs/toolkit';
import createGenericSlice, { GenericState } from '../wrapper/sliceWrapper';
import GitTrail from '../../utils/GitTrail/GitTrail';

export interface IReportStats {
  total: number;
  pull: number;
  push: number;
}
export interface IGitReport {
  date: string;
  org: { [key: string]: IReportStats };
  users: { [key: string]: IReportStats };
  repositories: { [key: string]: IReportStats };
}
export interface IGitReportData {
  start: string;
  end: string;
  status: string;
  report: string;
}

export interface IGitReportItem {
  id: string;
  report: IGitReportData;
}

const initialState: GenericState<Array<IGitReportItem> | null> = { data: null, status: 'loading' };

export const getAllGitReports = createAsyncThunk('reports/getGitReports', async () => {
  const gitTrail = new GitTrail();
  return await gitTrail.getGitTrailReports();
});

const trilReportSlice = createGenericSlice({
  name: 'trailReport',
  initialState,
  reducers: {
    // reset to initial state
    resetGitReportState: (state) => {
      state = initialState;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAllGitReports.pending, (state) => {
      state.status = 'loading';
    });

    builder.addCase(getAllGitReports.fulfilled, (state, action) => {
      state.status = 'finished';
      state.data = action.payload;
    });

    builder.addCase(getAllGitReports.rejected, (state, action) => {
      state.status = 'error';
      state.error = 'Something went wrong.';
    });
  }
});

export const { resetGitReportState } = trilReportSlice.actions;
export default trilReportSlice.reducer;
